<template>
	<div class="card">
		<div class="card-body flex-row d-flex">
			<div v-shortcuts="[{ shortcut: ['esc' ], callback: closeInput, once: true }]" class="d-flex w-100" :class="post && showPost ? $style.comment : null">
				<user-avatar :user="author" :tooltip="false" class="align-self-start mr-4" />
				<div class="flex-grow-1 w-100">
					<div class="d-flex flex-column" :class="{'border-bottom mb-3 pb-3': (replies.results.length > 0 && replies.enabled) || separator}">
						<div class="d-flex flex-wrap mb-2">
							<div class="mr-auto">
								<div class="text-gray-6">
									<span class="text-dark font-weight-bold">{{ author.username }}</span> escribió <span v-if="post" class="d-inline-block d-sm-none">en <router-link :to="{name: 'postEdit', params: {id: post.id}}" :data-status="post.status" class="pointer">#{{ post.id }}</router-link></span>
								</div>
								<div class="text-muted">
									{{ $moment(data.created_at).fromNow() }}
								</div>
							</div>
							<a-popconfirm
								title="¿Estás seguro que deseas borrar este comentario?"
								ok-text="Sí"
								cancel-text="No"
								tabindex="0"
								:class="$style.deleteComment"
								@confirm="deleteComment"
							>
								<a><fa-icon :icon="['fal','trash']" class="mr-2" /></a>
							</a-popconfirm>
							<!-- <div class="nav-item dropdown">
								<a-dropdown placement="bottomRight" :trigger="['click']">
									<a class="nav-link dropdown-toggle pt-0 pr-0" href="javascript: void(0);">
										Acciones
									</a>
									<a-menu slot="overlay">
										<a-menu-item>
											<a @click="openInput"><fa-icon :icon="['fal','reply']" class="mr-2" /> Responder</a>
										</a-menu-item>
										<a-menu-divider />
										<a-menu-item>
										</a-menu-item>
									</a-menu>
								</a-dropdown>
							</div> -->
						</div>
						<div class="mb-3 text-break">
							{{ parser().urlify(data.text) }}
						</div>
						<div class="d-flex flex-wrap justify-content-start align-items-start">
							<a class="mr-3" :class="{'text-blue': (data.likes > 0), 'text-muted': (data.likes === 0)}">
								<i class="icmn-heart mr-1" /> {{ data.likes }} Likes
							</a>
							<a v-if="!isReply && !replies.enabled" class="mr-3" :class="{'text-blue': (data.replies_count > 0), 'text-muted': (data.replies_count === 0)}" @click="openReplies">
								<i class="icmn-bubble mr-1" /> {{ data.replies_count }} Comentarios
							</a>
							<a v-else-if="!isReply && replies.enabled" class="text-danger mr-3" @click="replies.enabled = false">
								<fa-icon :icon="['far', 'times']" /> Cerrar
							</a>
							<a v-if="response.enabled" class="text-danger mr-3" @click="closeInput">
								<fa-icon :icon="['far', 'times']" /> Cerrar
							</a>
						</div>
						<div v-if="!isReply" class="row">
							<div class="col-12 mt-2 d-flex">
								<a-input-search ref="input" v-model:value="response.text" placeholder="Introduce tu mensaje..." enter-button="Enviar" @search="addReply" @press-enter.prevent="addReply">
									<template #addonBefore>
										<a-select default-value="user" style="width: 85px" @change="changeResponseTo">
											<a-select-option value="user">
												Usuario
											</a-select-option>
											<a-select-option value="post">
												Post
											</a-select-option>
										</a-select>
									</template>
								</a-input-search>
								<a-dropdown :trigger="['click']">
									<a class="ant-dropdown-link" @click="e => e.preventDefault()">
										<a-tooltip>
											<template #title>
												Respondiendo como {{ currentUser.username }}
											</template>
											<a-avatar :src="images().avatar(currentUser)" class="ml-2" @error="onAvatarError"><template #icon><a-icon type="user" /></template></a-avatar>
										</a-tooltip>
									</a>
									<template #overlay>
										<a-menu>
											<a-menu-item v-for="u in users" :key="u.id" @click="changeUserComment(u)">
												<a-avatar :src="images().avatar(u)" @error="onAvatarError">
													<template #icon>
														<a-icon type="user" />
													</template>
												</a-avatar> {{ u.username }}
											</a-menu-item>
										</a-menu>
									</template>
								</a-dropdown>
							</div>
						</div>
					</div>

					<div v-if="replies.enabled" :style="{ 'max-height': '500px', 'overflow-y': 'auto' }" class="mt-4">
						<comment v-for="(r,i) in replies.results" :key="r.id + '-reply'" :deal="post" :data="r" :is-reply="true" :separator="i < (replies.results.length - 1)" :parent="data" @reply-removed="removeReply" />

						<infinite-loading :identifier="data.id" @infinite="listReplies">
							<template #spinner>
								<div />
							</template>
							<template #no-results>
								<div />
							</template>
							<template #no-more>
								<div />
							</template>
						</infinite-loading>
					</div>
				</div>
			</div>
			<div v-if="post && showPost" class="d-none d-sm-block" @mouseover="() => loadDescDeal(post.id)">
				<router-link :to="{name: 'postEdit', params: {id: post.id}}" :data-status="post.status" class="pointer">
					<!--<a-tooltip placement="left">
						<template slot="title">
							<span>{{ post.name }}</span>
						</template>
						<img class="img-fluid m-0" :class="$style.image" :src="images().deal(post,200)" :alt="post.name">
					</a-tooltip>-->
					<a-popover :title="post.name">
						<template #content>
							<p>{{ postDesc }}</p>
							<a-spin :spinning="loadDesc" class="mx-auto d-block" />
						</template>
						<img class="img-fluid m-0" :class="$style.image" :src="images().deal(post,200)" :alt="post.name">
					</a-popover>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import InfiniteLoading from 'v3-infinite-loading';

export default {
	name: 'Comment',
	components: {
		InfiniteLoading,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
		isReply: {
			type: Boolean,
			default: false,
		},
		separator: {
			type: Boolean,
			default: false,
		},
		parent: {
			type: Object,
			default: null,
		},
		user: {
			type: Object,
			default: null,
		},
		deal: {
			type: Object,
			default: null,
		},
		showPost: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['removed-comment', 'replyRemoved', 'reply-to-post'],
	data() {
		return {
			replies: {
				enabled: false,
				results: [],
				total: 0,
			},
			response: {
				enabled: false,
				text: '',
			},
			responseTo: 'user',
			postDesc: '',
			loadDesc: false,
			users: [],
			currentUser: null,
		};
	},
	computed: {
		author() {
			if (this.data.user !== undefined) return this.data.user;
			return this.user;
		},
		post() {
			if (this.data.deal !== undefined) return this.data.deal;
			return this.deal;
		},
	},
	async created() {
		this.$hub.on('removeReplyFromParent', (id) => {
			if (this.replies.results.length > 0) {
				const find = this.replies.results.findIndex(r => r.id === id);
				if (find > -1) this.replies.results.splice(find, 1);

				if (this.replies.results.length === 0) this.replies.enabled = false;
			}
		});

		const currentUser = _.cloneDeep(this.$store.getters.user);

		this.currentUser = currentUser;

		const { data: usersFakeData } = await this.$http.get(`https://app.michollo.com/api/admin/users?user_id=${this.$store.getters.user.id}`, { Authorization: true });

		if (usersFakeData && usersFakeData.ok) this.users = [currentUser, ...usersFakeData.users.results];
	},
	unmounted() {
		this.$hub.off('removeReplyFromParent');
	},
	methods: {
		onAvatarError(e) { if (e && e.target) e.target.src = require('../../../assets/img/placeholder/avatar.jpg'); return false; },
		async listReplies($state) {
			const offset = this.replies.results.length;

			const results = await this.$sdk.comments().replies({ dealId: this.post.id, replyId: this.data.id, offset, limit: 10 });

			if (results.ok) {
				this.replies.results = results.data.results.concat(this.replies.results);

				if (results.data.results.length > 0) {
					return $state.loaded();
				}
			}

			return $state.complete();
		},
		async deleteComment() {
			const self = this;

			// this.$modal.confirm({
			// 	title: '¿Estas seguro de querer eliminar este comentario?',
			// 	content: () => <div style="color:red;">Se borrará para siempre</div>,
			// 	async onOk() {
			// 		const dealId = self.parent ? self.parent.deal.id : self.post.id;

			// 		const del = await self.$sdk.comments().delete(dealId, self.data.id);

			// 		if (del) {
			// 			self.$message.success('Comentario borrado correctamente');

			// 			if (!self.isReply) {
			// 				self.$store.dispatch('removeItem', { id: self.data.id, type: 'comments' });
			// 				self.$hub.emit('removeReplyFromParent', self.data.id);
			// 			} else {
			// 				self.$emit('replyRemoved', self.data.id);
			// 			}
			// 		}
			// 	},
			// });

			const dealId = self.parent ? self.parent.id : self.post.id;

			const del = await self.$sdk.comments().delete(dealId, self.data.id);

			if (del) {
				self.$message.success('Comentario borrado correctamente');

				if (!self.isReply) {
					self.$store.dispatch('removeItem', { id: self.data.id, type: 'comments' });
					self.$emit('removed-comment', self.data.id);
					self.$hub.emit('removeReplyFromParent', self.data.id);
				} else {
					self.$emit('replyRemoved', self.data.id);
				}
			}
		},
		openReplies() {
			if (this.data.replies_count > 0) this.replies.enabled = true;
		},
		openInput() {
			this.response.enabled = true;
			this.response.text = `@${this.author.username} `;
			setTimeout(() => { this.$refs.input.focus(); }, 200);
		},
		closeInput() {
			if (this.response.enabled) {
				this.response.enabled = false;
			}
		},
		removeReply(id) {
			const find = this.replies.results.findIndex(r => r.id === id);
			if (find > -1) this.replies.results.splice(find, 1);

			this.$store.dispatch('removeItem', { id, type: 'comments' });
		},
		async addReply() {
			if (this.response.text) {
				let result;
				let deal;
				let parentId = false;
				let dealId;
				let text;

				if (this.responseTo === 'user') {
					if (this.post) {
						deal = this.post;
					} else if (this.parent) {
						({ deal } = this.parent);
					} else {
						({ deal } = this.data);
					}
					dealId = deal.id;
					// eslint-disable-next-line prefer-destructuring
					text = this.response.text;
					parentId = this.data.id;
					// result = await this.$sdk.comments().add({ dealId: deal.id, text: this.response.text, parentId: this.data.id });
				} 	else if (this.responseTo === 'post') {
					deal = this.post;
					dealId = this.post.id;
					// eslint-disable-next-line prefer-destructuring
					text = this.response.text;
					// result = await this.$sdk.comments().add({ dealId: this.post.id, text: this.response.text });
				}

				try {
					let url;

					if (parentId) url = `deals/${dealId}/comments/${parentId}`;
					if (!parentId) url = `deals/${dealId}/comments`;

					const response = await this.$http.post(url, { text, user_id: this.currentUser.id }, { Authorization: true });
					result = response.data.comment.id;
				} catch (error) {
					result = false;
				}

				if (result) {
					if (this.responseTo === 'user') {
						const params = { ..._.cloneDeep(this.data), replies_count: this.data.replies_count + 1 };
						this.$store.dispatch('setItem', { id: this.data.id, data: params, type: 'comments' });
					}

					const data = _.cloneDeep({
						created_at: this.$moment(),
						deal,
						id: result,
						likes: 0,
						replies_count: 0,
						text: this.response.text,
						updated_at: null,
						user: this.currentUser,
					});

					if (this.responseTo === 'post') {
						this.$store.dispatch('addDataFirst', { data: { results: [data] }, type: 'comments' });
						this.$emit('reply-to-post', data);
					}	else if (this.responseTo === 'user') {
						if (this.replies.enabled) {
							this.replies.results = [data].concat(this.replies.results);
						} else {
							this.replies.enabled = true;
						}
					}

					this.$message.success('Respuesta enviada correctamente');

					this.response = {
						enabled: false,
						text: '',
					};
				}
			}
		},
		changeResponseTo(value) {
			this.responseTo = value;
		},
		async loadDescDeal(id) {
			if (this.postDesc === '') {
				this.loadDesc = true;
				const deal = await this.$sdk.deals().get(id);

				if (deal.ok) {
					let { description } = deal.data;

					description = this.stripHtml(description);

					if (description) this.postDesc = description.slice(0, 140);
					if (description.length > 140) this.postDesc += '...';
					this.loadDesc = false;
				}
			}
		},
		stripHtml(html) {
			const tmp = document.createElement('DIV');
			tmp.innerHTML = html;
			return tmp.textContent || tmp.innerText || '';
		},
		changeUserComment(selectedUser) {
			this.currentUser = selectedUser;
		},
	},
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>

<style scoped>
	.ant-popover-content {
		max-width: 250px;
	}
</style>
